<template lang="pug">
.agreement-box
  h2(v-if="message") {{ message }}
  .form-fields.init-terms-agreement-container
    label.radio-container(:for="name + 'Yes'")
      .p-l-5.p-t-2 {{ agreeLabel }}
      input(
        type="radio"
        :name="name"
        :id="name + 'Yes'"
        value="yes"
        v-model="termsAgreed"
        @change="$emit('input', 'yes')"
        )
      span.css-radio
    label.radio-container(:for="name + 'No'")
      .p-l-5.p-t-2 {{ disagreeLabel }}
      input(
        type="radio"
        :name="name"
        :id="name + 'No'"
        value="no"
        v-model="termsAgreed"
        @change="$emit('input', 'no')"
        )
      span.css-radio
</template>

<script>
export default {
  name: 'agree-to-terms',
  props: {
    message: {
      default: 'I HAVE READ & AGREE WITH ALL SUPERCHARGED TERMS & CONDITIONS'
    },
    agreeLabel: {
      default: 'I Agree'
    },
    disagreeLabel: {
      default: 'I Don\'t Agree'
    },
    name: {
      default: 'termsAgreed'
    },
    value: {
      default: 'no'
    }},
  data: () => ({
    termsAgreed: null
  }),
  watch: {
    value() {
      this.termsAgreed = this.value
    }
  },
  created() {
    this.termsAgreed = this.value
  }
}
</script>
